// force deployment!
import { createRoot } from 'react-dom/client';

//import * as Sentry from '@sentry/react';
import App from './App';

import './i18n';
import './utils/debug'; // Import de debug tools

// Sentry.init({
//   dsn: 'https://d6af18b683638baede818f6bc5112701@o280086.ingest.sentry.io/4506778987069440',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   enabled: process.env.NODE_ENV !== 'development',
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// Zorg dat we bij crashes toch nog de debug tools kunnen gebruiken
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    originalConsoleError(...args);
    // Log alleen React-gerelateerde fouten naar de debug tools
    if (typeof args[0] === 'string' && args[0].includes('React')) {
      console.log('[DEBUG] React error captured:', ...args);
    }
  };
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
